import moment from 'moment';

import { OUTPUT_CUSTOMER_DATE_FORMAT } from 'components/modules/Insurance/Insurance.constants';
import { CUSTOMER_ROLES, DRIVER_FIELDS } from 'store/insuranceAnketa/constants';

const ROLES = {
  [CUSTOMER_ROLES.INSURER]: 'страхователь',
  [CUSTOMER_ROLES.OWNER]: 'собственник',
};

const capitalizeFirstLetter = (letter) => {
  if (!letter) {
    return letter;
  }

  const [symbol, ...rest] = Array.from(letter);

  return symbol.toUpperCase() + rest.join('');
};

const generateDescriptionDate = (date) => {
  if (!date) {
    return;
  }

  const parsed = moment(date, OUTPUT_CUSTOMER_DATE_FORMAT);

  return parsed.format('DD.MM.YYYY');
};

export const generateDescription = ({
  [DRIVER_FIELDS.BIRTHDATE]: birthdate,
  [DRIVER_FIELDS.DRIVING_LICENSE_ISSUE_DATE]: drivingLicenseIssueDate,
  [DRIVER_FIELDS.DRIVING_LICENSE_SERIES_AND_NUMBER]: drivingLicenseSeriesAndNumber,
  [DRIVER_FIELDS.ROLES]: rolesParam = [],
}) => {
  const result = [generateDescriptionDate(birthdate)];
  const drivingLicense = [generateDescriptionDate(drivingLicenseIssueDate)];

  if (drivingLicenseSeriesAndNumber) {
    drivingLicense.unshift(`ВУ ${drivingLicenseSeriesAndNumber}`);
  }

  const roles = rolesParam
    .map((role) => {
      return ROLES[role];
    })
    .join(', ');

  result.push(drivingLicense.filter(Boolean).join(' от '), capitalizeFirstLetter(roles));

  return result.filter(Boolean).join(' • ');
};
